/** Presentational view-models for the v2 Candidates screens. */
import type { Tone } from '../../theme/tone';
import type { CandidateStatus, ConsentStatus } from '../../schemas/hire/candidateV2';

export function candStatusVM(status: CandidateStatus): { tone: Tone; label: string } {
  switch (status) {
    case 'active': return { tone: 'success', label: 'Active' };
    case 'consent_expired': return { tone: 'warn', label: 'Consent expired' };
    case 'erased': return { tone: 'danger', label: 'Erased' };
    case 'deactivated':
    default: return { tone: 'neutral', label: 'Deactivated' };
  }
}

export function consentVM(status: ConsentStatus): { tone: Tone; label: string } {
  switch (status) {
    case 'active': return { tone: 'success', label: 'Consent active' };
    case 'expired': return { tone: 'warn', label: 'Consent expired' };
    case 'withdrawn': return { tone: 'danger', label: 'Consent withdrawn' };
    case 'none':
    default: return { tone: 'neutral', label: 'No consent' };
  }
}
